import { update } from '@kundinos/nanostores';

import { orderFabricsStore } from './stores';

function resetSelectedSamples(): void {
  update(orderFabricsStore, (value) => ({
    ...value,
    selectedSamples: new Array(5).fill({ sample: null }),
  }));
}

export default resetSelectedSamples;
